import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  iconoirPlus,
  iconoirFolderPlus,
  iconoirUserPlus,
  iconoirCalendarPlus,
  iconoirRefreshDouble,
  iconoirTrash,
  iconoirTaskList,
  iconoirHouseRooms,
  iconoirGraphUp,
  iconoirChatBubble,
  iconoirWarningCircle
} from '@ng-icons/iconoir';
import { QUICK_ACTIONS, QuickActionFlow } from '../../../../constants';

/**
 * Palette « / » de la commande vocale (MOKA-206 Phase 3, Lot B) : liste
 * filtrée des actions rapides, ouverte par `VoiceChatThreadComponent` dès que
 * le brouillon commence par `/`.
 *
 * Choix clavier (documenté ici car c'est le point le plus discutable de ce
 * composant) : ce composant est PUREMENT présentatif, il ne possède AUCUN
 * `@HostListener`/écouteur clavier propre. Toute la navigation (↑/↓/Entrée/
 * Échap) est interceptée et gérée par `VoiceChatThreadComponent.onKeydown`,
 * qui possède déjà le `keydown` du textarea (pour son propre raccourci
 * Entrée = envoyer) — dupliquer un second point d'écoute clavier ici aurait
 * obligé à déplacer le focus DOM du textarea vers la palette puis à le
 * restaurer à chaque frappe, pour un bénéfice nul (l'utilisateur ne quitte
 * jamais le champ de saisie en tapant une commande `/`). `activeIndex` est
 * donc un simple `input()` piloté par le parent ; ce composant se contente
 * de le refléter visuellement et d'émettre `select`/`dismiss` sur interaction
 * souris/clavier locale (clic).
 */
@Component({
  selector: 'app-slash-command-palette',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIcon],
  viewProviders: [
    provideIcons({
      iconoirPlus,
      iconoirFolderPlus,
      iconoirUserPlus,
      iconoirCalendarPlus,
      iconoirRefreshDouble,
      iconoirTrash,
      iconoirTaskList,
      iconoirHouseRooms,
      iconoirGraphUp,
      iconoirChatBubble,
      iconoirWarningCircle
    })
  ],
  templateUrl: './slash-command-palette.component.html',
  styleUrl: './slash-command-palette.component.scss'
})
export class SlashCommandPaletteComponent {
  filterText = input('');
  activeIndex = input(0);

  select = output<QuickActionFlow>();
  dismiss = output<void>();

  filteredActions = computed(() => {
    const term = this.filterText().toLowerCase();
    return QUICK_ACTIONS.filter(action => action.label.toLowerCase().includes(term));
  });

  onSelect(flow: QuickActionFlow): void {
    this.select.emit(flow);
  }
}
